import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import type { Venue } from "@/types";

export function useVenues() {
  return useQuery({
    queryKey: ["venues"],
    queryFn: () => api.get<Venue[]>("/admin/venues"),
  });
}

export function useCreateVenue() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      name: string;
      address: string;
      latitude: number | null;
      longitude: number | null;
    }) => api.post<Venue>("/admin/venues", body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["venues"] }),
  });
}

export function useUpdateVenue() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({
      id,
      body,
    }: {
      id: string;
      body: Partial<{
        name: string;
        address: string;
        latitude: number | null;
        longitude: number | null;
        isHidden: boolean;
      }>;
    }) => api.put<Venue>(`/admin/venues/${id}`, body),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["venues"] }),
  });
}

export function useToggleVenueVisibility() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => api.delete(`/admin/venues/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ["venues"] }),
  });
}
